import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const LANGS = ["fr", "en", "es", "it"];
const STORAGE_KEY = "evara_lang";

const LanguageContext = createContext(null);

const getDeep = (obj, path) =>
  path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);

export const LanguageProvider = ({ children, dictionaries }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "fr";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return LANGS.includes(stored) ? stored : "fr";
  });

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path, fallback = "") => {
      const fromLang = getDeep(dictionaries[lang], path);
      if (fromLang !== undefined) return fromLang;
      const fromFr = getDeep(dictionaries.fr, path);
      return fromFr !== undefined ? fromFr : fallback || path;
    },
    [lang, dictionaries]
  );

  const value = useMemo(
    () => ({ lang, setLang, t, langs: LANGS }),
    [lang, t]
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useT = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
};
